import axios from "axios";

export const sendFeedback = async (module_id: string, page_id, meta, feedback) => {
    const res = await axios.post("/messaging/feedback", { module_id, page_id, meta, feedback });

    return res.data;
};
